import { render, staticRenderFns } from "./gjqk.vue?vue&type=template&id=76ede25d&"
import script from "./gjqk.vue?vue&type=script&lang=js&"
export * from "./gjqk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports